
    import axios, { AxiosResponse } from 'axios';
    
    import { defineComponent } from 'vue';
    import * as jQuery from 'jquery';
    import { Field, Form, ErrorMessage, useForm } from 'vee-validate';
    import * as yup from 'yup';
    import { String as StringS } from 'typescript-string-operations';

     class MigrateAccountPostModel {
        public password: string = "";
        public newsletter: boolean = false;
       
    }

    export class MigrateAccountValidateResult {
        public success: boolean = false;
        public errormsg: string = "";
    }

    export default defineComponent({
        components: { Field, Form, ErrorMessage },
        data() {
            const regex: RegExp = new RegExp("[^\w\d]*(([0-9]+.*[A-Za-z]+.*)|[A-Za-z]+.*([0-9]+.*))");
            const schema = yup.object({
                dc_migratepassword: yup.string().required(this.view_migrateaccount_validate_requis).max(32, StringS.Format(this.view_migrateaccount_validate_tropchars as string, 32)).min(8, StringS.Format(this.view_migrateaccount_validate_minimumchars as string, 8)).matches(regex, this.view_migrateaccount_validate_letternum),
                dc_migratepasswordverify: yup.string().required(this.view_migrateaccount_validate_requis).max(32, StringS.Format(this.view_migrateaccount_validate_tropchars as string, 32)).min(8, StringS.Format(this.view_migrateaccount_validate_minimumchars as string, 8)).matches(regex, this.view_migrateaccount_validate_letternum).oneOf([yup.ref("dc_migratepassword")], this.view_migrateaccount_passdifferent),
     
            });
            return {
                schema,
                passwordverify: "",
                password: "",
                newsletter: false,
                statusmsg: "",
                returnurl: ""
            };
        },
        props: {
            view_migrateaccount_pass: String,
            view_migrateaccount_passverif: String,
            view_migrateaccount_btnnext: String,
            view_migrateaccount_mailinglist: String,
            view_migrateaccount_btnvalider: String,
            view_migrateaccount_passdifferent: String,
            view_migrateaccount_titlepage1: String,
            view_migrateaccount_validate_requis: String,
            view_migrateaccount_validate_tropchars: String,
            view_migrateaccount_validate_minimumchars: String,
            view_migrateaccount_validate_letternum: String
        },

        mounted() {
            this.returnurl = jQuery("#returnurlmodal").val() as string;
        },
        methods: {

            Valider() {
                let data: MigrateAccountPostModel = new MigrateAccountPostModel();
                data.password = this.password;
                data.newsletter = this.newsletter;
                this.Migrate(data);
            },


            Migrate(data: MigrateAccountPostModel) {
                let self = this;
                axios.post<MigrateAccountValidateResult>("/api/v1/migrateaccount/migrate", data).then(function (response: AxiosResponse<MigrateAccountValidateResult>) {
                    if (!response.data.success)
                        self.statusmsg = response.data.errormsg;
                    else {
                        if (self.returnurl == "")
                            window.location.reload();
                        else
                            window.location.href = self.returnurl;
                    }
                });
            }
        }
    });
